import { Dialog, Transition } from "@headlessui/react";
import {
  Scanner,
  boundingBox,
  centerText,
  outline,
} from "@yudiel/react-qr-scanner";
import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decodeQrCode } from "../../core/service/api_pickup_student";
import "./pickup.css";
const previewStyle = {
  height: 320,
  width: 320,
};
const styles = {
  container: {
    width: "100%",
    margin: "auto",
  },
  controls: {
    marginBottom: 8,
  },
};

const QrCodeScanner = ({ devices }) => {
  // const devices = useDevices();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const qrScannerRef = useRef(null);
  const query = useParams();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const [isScaningOpen, setIsScaningOpen] = useState(false);
  const [tracker, setTracker] = useState("centerText");
  const [status, setstatus] = useState("");
  const [delay, setDelay] = useState(100);
  const [result, setResult] = useState(null);
  const [deviceId, setDeviceId] = useState("");
  const [pause, setPause] = useState(false);
  const [data, setData] = useState("No result");

  function getTracker() {
    switch (tracker) {
      case "outline":
        return outline;
      case "boundingBox":
        return boundingBox;
      case "centerText":
        return centerText;
      default:
        return undefined;
    }
  }

  const handleScan = async (result) => {
    console.log(result);

    if (result) {
      try {
        setResult(result);
        console.log("QR Code scanned:", result);
        let params = [];
        params.push(`anjunganId=${result[0].rawValue}`);
        params.push(`studentId=${query.studentId}`);
        params.push(`std_class=${query.grade}`);
        // qrScannerRef.current.pause();
        setPause(true);
        await decodeQrCode(params);
        setstatus("success");
        openScanModal();
      } catch (error) {
        setPause(false);
      }
    }
  };

  const handleSuccess = async (result) => {
    if (result) {
      try {
        setData(result.text);
        console.log("QR Code scanned:", result);
        let params = [];
        params.push(`anjunganId=${result.text}`);
        params.push(`studentId=${query.studentId}`);
        params.push(`std_class=${query.grade}`);
        await decodeQrCode(params);
        setstatus("success");
        openScanModal();
      } catch (error) {
        alert(error);
        // setPause(false);
      }
    }
  };

  const handleError = (err) => {
    // console.error(err);
    setData("");
  };

  function openScanModal() {
    setIsScanOpen(true);
  }

  function closeScanModal() {
    setIsScanOpen(false);
    navigate(`/pickup-student`);
  }

  function openScaningModal() {
    setIsScaningOpen(true);
  }

  function closeScaningModal() {
    setDeviceId("");
    setIsScaningOpen(false);
  }
  useEffect(() => {
    if (deviceId) openScaningModal();
  }, [deviceId]);

  useEffect(() => {
    return;
  }, []);

  return (
    <>
      {/* <div className="qr-scanner-container">
        <span className="qr-scanner-placeholder">waiting...</span>
        <video className="qr-scanner-video" ref={videoRef} />
      </div> */}
      <div style={styles.container}>
        <select value={deviceId} onChange={(e) => setDeviceId(e.target.value)}>
          <option value={""}>Select a device</option>
          {devices.map((device, index) => (
            <option key={index} value={device.deviceId}>
              {device.label}
            </option>
          ))}
        </select>
        <Scanner
          scanDelay={delay}
          constraints={{
            deviceId: deviceId,
          }}
          onScan={(result) => result && handleScan(result)}
          components={{
            tracker: getTracker(),
          }}
        />

        {/* <Scanner
          scanDelay={delay}
          paused={pause}
          onScan={handleScan}
          constraints={{
            deviceId: deviceId,
          }}
          components={{
            audio: true,
            // onOff: true,
            torch: true,
            zoom: true,
            finder: true,
            tracker: getTracker(),
          }}
        /> */}
      </div>
      {/* <QrReader
        constraints={{ facingMode: "environment" }}
        onResult={(result, error) => {
          if (!!result) {
            setData(result?.text);
            handleSuccess(result);
            // alert(result?.text);
          }

          if (!!error) {
            handleError(error);
            // console.info(error);
          }
        }}
        style={{ width: "100%" }}
      /> */}
      {/* <Transition appear show={isScaningOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeScaningModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-xl text-center font-medium leading-6 text-gray-900"
                  >
                    <Scanner
                      scanDelay={delay}
                      constraints={{
                        deviceId: deviceId,
                      }}
                      onScan={(result) => result && handleScan(result)}
                    />
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary text-base mt-3 p-2 flex flex-col gap-2 justify-center items-center">
                    <button
                      type="button"
                      onClick={closeScaningModal}
                      className=" bg-[#FEB139] py-2 px-3 font-bold text-white rounded-xl "
                    >
                      Kembali
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition> */}

      <Transition appear show={isScanOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeScanModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-xl text-center font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row text-center">Sukses</div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary text-base mt-3 p-2 flex flex-col gap-2 justify-center items-center">
                    <span>
                      Berhasil menambahkan ke daftar antrian, Silakan menunggu
                      nama siswa / santri dipanggil
                    </span>
                    <button
                      type="button"
                      onClick={closeScanModal}
                      className=" bg-[#FEB139] py-2 px-3 font-bold text-white rounded-xl "
                    >
                      Kembali
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default QrCodeScanner;
